import { Guid } from "devextreme-vue/common";
const getTimestamp = (date, offsetMinutes = 0) => {
  return date.getTime() + offsetMinutes * 60000;
};
const date = new Date();
import chatIcon from "@/assets/icons/chatbot.svg";

const state = () => ({
  showChat: false,
  supportAgent: {
    id: "d16d1a4c-5c67-4e20-b7v0e-2991c22747c3",
    name: "assistant",
    avatarUrl: chatIcon,
  },
  currentChatMessages: [],

  currentUser: {
    id: "c94c0e76-fb49-4b9b-8f07-9f93ed93b4f3",
    name: "user",
  },
  settings: {},
});

const getters = {};

const actions = {};

const mutations = {
  updateShowChat(state, val) {
    state.showChat = val;
  },
  addMessageToChat(state, val) {
    state.currentChatMessages.push(val);
  },
  fillSettings(state, val) {
    state.settings = val;
  },
  resetCurrentMessages(state) {
    state.currentChatMessages = [
      {
        id: new Guid().toString(),
        timestamp: getTimestamp(date, -9),
        author: state.supportAgent,
        text: state.settings.introText,
      },
    ];
    if (
      JSON.parse(sessionStorage.getItem("chatMessages")) == null ||
      JSON.parse(sessionStorage.getItem("chatMessages")).length == 0
    )
      sessionStorage.setItem(
        "chatMessages",
        JSON.stringify(state.currentChatMessages)
      );
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
